export default "__VITE_ASSET__CPjmOTqn__"